<template>
  <section v-if="res">
    <div class="section_search">
      <div class="tray">
        <div class="row">
          <div class="cell">
            <dl class="target_info">
              <dt class="name">{{res.rcpName}}</dt>
              <dd class="personal">({{res.rcpGender}}/{{res.rcpAge}}세/{{res.orgFullName}})</dd>
              <dd class="member">NUGU Device No: {{res.deviceId}} | TID : {{res.tid}}</dd>
              <dd class="member">최근 이용날짜: {{res.lastUseDate}}</dd>
            </dl>
          </div>
        </div>
      </div>
    </div>

    <ul class="section_tab">
      <li v-for="item in tabArr" class="cell" :key="item.name">
        <a
          href="#"
          class="item"
          :class="{selected: item.comp === currentTab}"
          @click.prevent="onClickItem(item.comp)"
        >{{item.name}}</a>
      </li>
    </ul>

    <component v-if="res" :is="currentTab" :rcpDetail="res" />
  </section>
</template>

<script>
import Daily from "./Detail.daily";
import Dementia from "./Detail.dementia";

export default {
  components: { Daily, Dementia },
  data() {
    const rcpId = this.$route.params.id;
    return {
      res: null,
      rcpId,
      currentTab: "Daily",
      tabArr: [
        { name: "Daily 이용통계", comp: "Daily" },
        { name: "기억검사 결과", comp: "Dementia" }
      ]
    };
  },
  mounted() {
    this.$axios
      .get(`/admin/happy/stats/v2/user/detail`, {
        params: { rcpId: this.rcpId }
      })
      .then(({ data }) => {
        this.res = data;
      });
  },
  methods: {
    onClickItem(comp) {
      this.currentTab = comp;
    }
  }
};
</script>